// noinspection JSBitwiseOperatorUsage

export default {
    methods: {
        getBusinessProcessState(value, type) {
            type = type || "name";

            if (value & (1 << 6)) {
                return {
                    name: "Опубликовано",
                    class: "bp_is_published",
                    step: 7,
                    color: 'white'
                }[type];
            }

            if (value & (1 << 0)) {
                return {
                    name: "Отклонено",
                    class: "bp_is_declined",
                    step: 2.5,
                    color: 'grey lighten-2'
                }[type];
            }

            if (value & (1 << 5)) {
                return {
                    name: "Ожидает публикации",
                    class: "bp_is_approved",
                    step: 6,
                    color: 'deep-orange lighten-2',
                }[type];
            }
            if (value & (1 << 4)) {
                return {
                    name: "Утверждено",
                    class: "bp_approved_by_moderator",
                    step: 5,
                    color: 'blue lighten-3'
                }[type];
            }
            if (value & (1 << 3)) {
                return {
                    name: "Отправлено на&nbsp;утверждение",
                    class: "bp_approved_by_approver",
                    step: 4,
                    color: 'purple accent-1'
                }[type];
            }
            if (value & (1 << 2)) {
                return {
                    name: "Предложено к&nbsp;публикации",
                    class: "bp_approved_by_editor",
                    step: 3,
                    color: 'light-green lighten-3'
                }[type];
            }
            if (value & (1 << 1)) {
                return {
                    name: "В&nbsp;работе",
                    class: "bp_is_in_progress",
                    step: 2,
                    color: 'teal lighten-3'
                }[type];
            }

            return {
                name: "Не&nbsp;обработано",
                class: "bp_is_new",
                step: 1,
                color: 'yellow lighten-4'
            }[type];
        },
    }
};
